($ => {

	'use strict';

	function init() {
		initFilters();
		initMap();
		buildMarkers();
		initEventListeners();
	};

	function buildMarkers() {
		if (!GMAP_CI.markersData || !GMAP_CI.map) {
            return;
        }
		// Creation des objets Market et evenet d'ouverture d'InfoWindow avec le contenu associé
		$.each(GMAP_CI.markersData, (i, markerItem) => {
			// Create marker
			GMAP_CI.markersData[i].marker = new google.maps.Marker({
				position: new google.maps.LatLng(
					markerItem.lat,
					markerItem.lng
				),
			});

			// Set marker icon
			toggleActiveIcon(GMAP_CI.markersData[i], false);

			// Add markers object to clusterer and spiderfier
			GMAP_CI.clusterer.addMarker(GMAP_CI.markersData[i].marker);

			// Click event
			GMAP_CI.markersData[i].marker.addListener("click", () => {
				resetIcons();

				const domMarker = $('.mapList__resultItem[data-id="' + markerItem.id + '"]');
				if (domMarker.hasClass('not-selected') || !$('.mapList__resultItem.not-selected').length) {
					// Disable every items except the clicked on
					$('.mapList__resultItem:not(.not-selected)').addClass('not-selected');
					domMarker.removeClass('not-selected');
					if (window.innerWidth < 992) {
						domMarker.clone().appendTo('.mapList__mapPopup__content');
						$('.mapList__mapPopup').addClass('active');
					}

					// Set active icon when clicked
					toggleActiveIcon(GMAP_CI.markersData[i], true);
				} else {
					// Disable every items
					$('.mapList__resultItem.not-selected').removeClass('not-selected');
					$('.mapList__mapPopup__content').empty()
					$('.mapList__mapPopup').removeClass('active');
				}

				checkCategoriesToDisplay('not-selected');
			});
		});
	}

	function resetIcons() {
		$.each(GMAP_CI.markersData, j => {
			toggleActiveIcon(GMAP_CI.markersData[j], false);
		});
	}

	function toggleActiveIcon(markerData, active) {
		const size = active ? new google.maps.Size(30, 40) : new google.maps.Size(22, 33);
		markerData.marker.setIcon({
			url: markerData.iconUrl,
			scaledSize: size,
		});
	}

	function initFilters() {
		GMAP_CI.params = {
			'address': {
				'lat': false,
				'lng': false
			},
			'range': 10,
			'filters': {}
		};
		retrieveCheckboxFilters();
	}

	function retrieveRange() {
		let isServiceProximiteDomicile = true;
		const zoomLevelPerRange = {
			'50': 8,
			'40': 9,
			'30': 9,
			'20': 10,
			'10': 11,
			'0': 8,
		}


		for (const filter in GMAP_CI.params.filters) {

			isServiceProximiteDomicile = (
				(filter == "services-de-proximite" && GMAP_CI.params.filters[filter])
				|| (filter != "services-de-proximite" && !GMAP_CI.params.filters[filter])
			);
			if (!isServiceProximiteDomicile) {
				break;
			}
		}

		const forcedRange = isServiceProximiteDomicile
			? 50
			: (GMAP_CI.params.address.lat && GMAP_CI.params.address.lng)
				? 10
				: false;
		if (forcedRange) {
			GMAP_CI.params.range = forcedRange;
			$('.mapFilters__location__range input[type="range"]').val(forcedRange);
			$('.mapFilters__location__range__desc span').text(forcedRange + ' Km');
		} else {
			GMAP_CI.params.range = $('.mapFilters__location__range input[type="range"]').val();
		}
		GMAP_CI.map.setZoom(zoomLevelPerRange[GMAP_CI.params.range]);
	}

	function retrieveCheckboxFilters() {
		$('.mapFilters__categories__item').each((i, e) => {
			const checkbox = $(e).find('input[type="checkbox"]');
			GMAP_CI.params.filters[checkbox.attr("name")] = checkbox.is(":checked");
		});
	}

	// Calculate distance in Km between 2 coord
	// coords objects must have two properties : 'lat' and 'lng'
	function distanceBetweenCoords(a, b) {
		if ('lat' in a && 'lng' in a && 'lat' in b && 'lng' in b) {
			const R = 6371.009; // Radius of the Earth in Km
			const rLatA = a.lat * (Math.PI / 180); // Convert degrees to radians
			const rLatB = b.lat * (Math.PI / 180); // Convert degrees to radians
			const diffLat = rLatB - rLatA; // Radian difference (latitudes)
			const diffLng = (b.lng - a.lng) * (Math.PI / 180); // Radian difference (longitudes)
			const d = 2 * R * Math.asin(Math.sqrt(Math.sin(diffLat / 2) * Math.sin(diffLat / 2) + Math.cos(rLatA) * Math.cos(rLatB) * Math.sin(diffLng / 2) * Math.sin(diffLng / 2)));
			return d;
		}
		console.error("Coordinates objects must have 'lat' and 'lng' properties");
		return false;
	}

	function setDefaultMapCenter() {
		GMAP_CI.map.setCenter(new google.maps.LatLng(48.1056857, -1.6911753));
	}

	function initMap() {
		if (typeof google === "undefined" || typeof google.maps === "undefined") {
            return;
        }

        if (!google.maps.MapTypeId) {
            return;
        }
		// Initialisation de la map
		GMAP_CI.map = new google.maps.Map($('#map')[0], {
			zoom: 8,
			// center				: new google.maps.LatLng(48.1056857, -1.6911753),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			clickableIcons: false
		});

		setDefaultMapCenter();

		// Initialisation du cluster
		GMAP_CI.clusterer = new MarkerClusterer(GMAP_CI.map, [], {
			maxZoom: 14,
			gridSize: 50,
			styles: [MarkerClusterer.withDefaultStyle({
				width: 48,
				height: 72,
				url: GMAP_CI.templateUrl + "/images/pin_cluster.svg",
				textColor: "#FFFFFF",
				textSize: 20,
				anchorText: [-10, 0],
			})],
		});

		// Initialisation du geocoder
		GMAP_CI.geocoder = new google.maps.Geocoder();
	}

	function initEventListeners() {
		$('.mapFilters__location__range input[type="range"]').on('input', updateRangeText);
		$('.mapFilters__categories__item').on('click', updateCheckbox);
		$('.mapList__switcher__item, .mapFilters__switcher__item').on('click', switchDisplay);
		$('.mapFilters__title').on('click', toggleFilters);
		$('.mapFilters__search button').on('click', e => {
			e.preventDefault();
			executeSearch();
		});
		$('.mapFilters__categories__reset button').on('click', resetfilters);
		$('.mapList__mapPopup__close').on('click', e => {
			e.preventDefault();
			$('.mapList__mapPopup__content').empty();
			$('.mapList__mapPopup').removeClass('active');
		})
	}

	function resetfilters() {
		// Reset checkbox, check every unchecked inputs
		$('.mapFilters__categories__item').each((i, e) => {
			const item = $(e);
			if (!item.find('input[type="checkbox"]').is(':checked')) {
				item.click();
			}
		});
		// Reset search field
		$('.mapFilters__location__search input[type="search"]').val('');
		// Reset range field
		$('.mapFilters__location__range input[type="range"]').val(0);

		setDefaultMapCenter();

		executeSearch();
	}

	function checkCategoriesToDisplay(className) {
		$('.mapList__list__cat').each((i, e) => {
			const catDom = $(e);
			if (!catDom.find('.mapList__resultItem:not(.' + className + ')').length) {
				catDom.addClass(className);
			} else {
				catDom.removeClass(className);
			}
		});
	}

	function executeSearch() {
		const address = $('.mapFilters__location__search input[type="search"]').val();
		GMAP_CI.geocoder.geocode({ 'address': address }, (results, status) => {
			if (
				status == google.maps.GeocoderStatus.OK
				&& results.length
			) {
				const result = results[0];
				const lat = result.geometry.location.lat();
				const lng = result.geometry.location.lng();
				GMAP_CI.map.setCenter(new google.maps.LatLng(lat, lng));
				GMAP_CI.params.address = {
					'lat': lat,
					'lng': lng
				};
			} else {
				GMAP_CI.params.address = {
					'lat': false,
					'lng': false
				};
			}

			// Reset marker icon's sizes and display every DOM content
			resetIcons();
			$('.mapList__resultItem.disabled, .mapList__list__cat.disabled').removeClass('disabled');
			$('.not-selected').removeClass('not-selected');
			$('.mapList__mapPopup__content').empty();
			$('.mapList__mapPopup').removeClass('active');

			retrieveCheckboxFilters();
			retrieveRange();

			GMAP_CI.clusterer.clearMarkers();
			// Parse markers to hide and/or display
			$.each(GMAP_CI.markersData, (i, markerItem) => {
				if (shouldDisplayMarker(markerItem)) {
					GMAP_CI.clusterer.addMarker(GMAP_CI.markersData[i].marker);
					$('.mapList__resultItem[data-id="' + markerItem.id + '"]').removeClass('disabled');
				} else {
					$('.mapList__resultItem[data-id="' + markerItem.id + '"]').addClass('disabled');
				}
			});
			checkCategoriesToDisplay('disabled');
		});

		if ($('.mapFilters').hasClass('mobileActive')) {
			$('.mapFilters__content').slideToggle(200);
			$('.mapFilters').toggleClass('mobileActive');
		}
	}

	function shouldDisplayMarker(item) {
		if (
			GMAP_CI.params.address.lat
			&& GMAP_CI.params.address.lng
			&& GMAP_CI.params.range != 0
		) {
			if (distanceBetweenCoords(GMAP_CI.params.address, item) > GMAP_CI.params.range) {
				// Out of range
				return false;
			}
		}

		if (item.filter && item.filter in GMAP_CI.params.filters) {
			return GMAP_CI.params.filters[item.filter];
		}

		// Fallback, should display if no previous condition was met
		return true;
	}

	function toggleFilters(e) {
		if (window.innerWidth < 992) {
			e.preventDefault();
			$('.mapFilters__content').slideToggle(200);
			$('.mapFilters').toggleClass('mobileActive');
		}
	}

	function switchDisplay(e) {
		const selector = $(e.currentTarget).data('selector');
		$('.mapList, .mapFilters').attr('data-active', selector);
	}

	function updateCheckbox(e) {
		const target = $(e.target);
		if (!target.is("input")) {
			const item = $(e.currentTarget);
			const checkbox = item.find('input[type="checkbox"]');
			checkbox.click();
		}
	}

	function updateRangeText(e) {
		const value = $(e.target).val();
		$('.mapFilters__location__range__desc span').text(value + ' Km');
	}

	window.initGoogleMap = function () {
        if ($('body.page-template-template-listing-etablissements').length) {
            init();
        }
    };

    $(document).ready(() => {
        if (typeof google !== "undefined" && typeof google.maps !== "undefined") {
            initGoogleMap();
        }
    });

})(jQuery);
